import React from 'react';
import styled from 'styled-components';

export default function CompareResponsesHeaderDisplay ({activityName}) {

    return (
		<StyledCompareResponsesHeaderDisplay className="StyledTrackChangesHeaderDisplay">
			<section className="compare-responses-header-display-Wrapper">
				<section className="compare-responses-title-section">
					<h1 className="compare-responses-title-heading">{activityName}</h1>
				</section>
			</section>
		</StyledCompareResponsesHeaderDisplay>
	);
}

const StyledCompareResponsesHeaderDisplay = styled.section`
	.compare-responses-title-section {
		display: flex;
		width: 100%;
		flex-direction: column;
		.compare-responses-title-heading {
			font-size: var(--px-32);
			font-weight: 400;
			line-height: var(--px-42);
			color: var(--neutrals-1000);
			margin: 0 0 var(--px-26) 0;
		}
		.compare-responses-subtitle-snapshot-version {
			display: flex;
			width: 100%;
			align-items: center;
			.snapshotVersionSelectedText {
				font-size: var(--px-15);
				font-weight: 600;
				line-height: var(--px-24);
				color: var(--neutrals-900);
				margin-right: var(--px-10);
			}
			.selectText {
				display: flex;
				width: auto;
				background-color: var(--neutrals-00white);
				border: var(--px-1) solid var(--neutrals-200);
				padding: var(--px-6) var(--px-16);
				border-radius: var(--px-20);
				.snapshotOptionNameLabelWrapper,
				.snapshotOptionDateLabelWrapper {
					max-width: var(--px-250);
					.ellipses {
						div {
							font-size: var(--px-15);
							font-weight: 600;
							line-height: var(--px-24);
							color: var(--neutrals-900);
						}
					}
				}
				.snapshotOptionHyphenWrapper {
					margin: var(--px-1) var(--px-5) 0;
					font-size: var(--px-40);
				}
			}
		}
	}
`;